import { FormEvent, useEffect, useState } from 'react';
import './Library.css';
import { UserBookServiceFactory } from '../ServiceFactrories/UserBookServiceFactory';
import { CompleteUserBook } from '../../../generated/client';
import React from 'react';
import { UserBookResultsComponent } from './UserBookResultsComponent';
import { Button, Input } from '@chakra-ui/react';
import { UserBookCreationComponent } from './UserBookCreationComponent';
import { LibraryLoginServiceFactory } from '../ServiceFactrories/LibraryLoginServiceFactory';
// import toast
import { useToast } from '@chakra-ui/react';

/**
 * The BookSearchViewer monitors the player's interaction with a BookSearchArea on the map:
 * displaying the search popup for a books in the library
 */

export function UserBookSearchBar(): JSX.Element {
  const userBooksService = UserBookServiceFactory.instance();
  const loginService = LibraryLoginServiceFactory.instance();
  // arrary of books
  const [userBookList, setUserBookList] = useState<CompleteUserBook[]>([]);
  // string to be used to call listBooks
  const [keyword, setKeyword] = useState<string>('');

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [userId, setUserId] = useState<string>('');

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const refreshList = async () => {
    const query = keyword;
    let response = await userBooksService.getBooksForAuthor(userId);

    if (query) {
      response = await userBooksService.getBooksForAuthor(userId, query);
    }

    setUserBookList(response);
  };

  const search = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.target as HTMLFormElement;
    const input = form.querySelector('#searchText') as HTMLInputElement;
    if (input.value === keyword) {
      await refreshList();
    }
    setKeyword(input.value);
  };

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError] = useState('');
  const [passwordError] = useState('');
  const [hasAccount, setHasAccount] = useState(false);
  const toast = useToast();

  const handleLogin = async () => {
    try {
      const response = await loginService.loginAndReturnExistingUser(email, password);
      toast({
        title: 'Account created',
        description: 'You are logged in!',
        status: 'success',
        duration: 9000,
        isClosable: true,
        position: 'top-right',
      });
      if (response) {
        setUserId(response.userId);
      }
    } catch (error) {
      console.error('Error logging in: ', error);
      toast({
        title: 'Error logging in',
        description: 'Try signing up! or Check the password.',
        status: 'error',
        duration: 9000,
        isClosable: true,
        position: 'top-right',
      });
    }
  };

  const handleSignup = async () => {
    try {
      const response = await loginService.createNewUser(email, password);
      console.log(response);
      toast({
        title: 'Account created',
        description: 'You are signed up!',
        status: 'success',
        duration: 9000,
        isClosable: true,
        position: 'top-right',
      });

      if (response) {
        setUserId(response.userId);
      }
    } catch (error) {
      console.error('Error signing up: ', error);
      toast({
        title: 'Error logging in',
        description: 'Please try again/Account may already exist.',
        status: 'error',
        duration: 9000,
        isClosable: true,
        position: 'top-right',
      });
    }
  };

  useEffect(() => {
    (async () => {
      const query = keyword;
      let response = await userBooksService.getBooksForAuthor(userId);

      if (query) {
        response = await userBooksService.getBooksForAuthor(userId, query);
      }

      setUserBookList(response);
    })();
  }, [keyword, userBooksService, userId]);

  if (!userId) {
    // login functionality
    return (
      <section className='login'>
        <div className='loginContainer'>
          <label>Email</label>
          <Input
            type='email'
            value={email}
            required
            onChange={e => setEmail(e.target.value)}></Input>
          <p className='errorMsg'>{emailError}</p>
          <label>Password</label>
          <Input
            type='password'
            required
            value={password}
            onChange={e => setPassword(e.target.value)}></Input>
          <p className='errorMsg'>{passwordError}</p>
          <div className='btnContainer'>
            {hasAccount ? (
              <>
                <Button
                  style={{ width: 400, marginBottom: 10 }}
                  colorScheme='teal'
                  onClick={handleLogin}>
                  {' '}
                  Log In
                </Button>
                <p>
                  Do not have an account?{' '}
                  <Button
                    style={{ width: 400, marginBottom: 10 }}
                    colorScheme='teal'
                    onClick={() => setHasAccount(!hasAccount)}>
                    Sign Up
                  </Button>
                </p>
              </>
            ) : (
              <>
                <Button
                  style={{ width: 400, marginBottom: 10 }}
                  colorScheme='teal'
                  onClick={handleSignup}>
                  Sign Up
                </Button>
                <p>
                  Already have an account?{' '}
                  <Button
                    style={{ width: 400, marginBottom: 10 }}
                    colorScheme='teal'
                    onClick={() => setHasAccount(!hasAccount)}>
                    Log In
                  </Button>
                </p>
              </>
            )}
          </div>
        </div>
      </section>
    );
  }

  return (
    <div className='wrap'>
      <p>
        Welcome to the Covey.Town Writing Center! Browse and edit your existing books, or create a
        new book!
      </p>
      <br />
      <Button
        style={{ width: 400, marginBottom: 10, marginLeft: 15 }}
        colorScheme='teal'
        onClick={openModal}>
        Create New Book
      </Button>
      <br />
      <UserBookCreationComponent
        isCreateNewBookMode={true}
        isOpen={isModalOpen}
        userId={userId}
        closeModal={closeModal}
        refreshList={refreshList}></UserBookCreationComponent>
      <div>
        <form className='searchForm' onSubmit={event => search(event)}>
          <input style={{ margin: 10 }} id='searchText' type='text' className='searchTerm' />
          <button style={{ margin: 10 }} className='searchButton'>
            Search
          </button>
        </form>
      </div>
      <div className='resultsContainer'>
        {keyword && (
          <div className='resultsDescription'>
            <b>Showing Results for {keyword} ... </b>
          </div>
        )}

        {userBookList.map(book => (
          <UserBookResultsComponent
            key={book.id}
            book={book}
            userId={userId}
            refreshList={refreshList}></UserBookResultsComponent>
        ))}
      </div>
    </div>
  );
}
